import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-item-length',
    templateUrl: './item-length.component.html',
    styleUrls: ['./item-length.component.scss'],
    standalone: false
})
export class ItemLengthComponent implements OnChanges {

  @Input() itemLength: UntypedFormControl;

  ngOnChanges() { }
}
